module.exports = __webpack_public_path__ + "static/media/lunaMobile.12ec00d3.svg";